import { render, staticRenderFns } from "./Operation.vue?vue&type=template&id=9dab2cd2&"
import script from "./Operation.vue?vue&type=script&lang=js&"
export * from "./Operation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabs,QTab,QSeparator,QTabPanels,QTabPanel})
